export default __webpack_public_path__ + "static/media/btn_character_alignment_left.f5cbb15e.svg";